export const expiresInDaysOptions = [
  { value: -1, label: 'Never expires' },
  { value: 30, label: 'After 30 days' },
  { value: 90, label: 'After 90 days' },
  { value: 365, label: 'After 1 year' },
  { value: 730, label: 'After 2 years' },
  { value: 1095, label: 'After 3 years' },
];

export const keyLengthOptions = [
  { value: 2048, label: '2048 bits' },
  { value: 3072, label: '3072 bits' },
  { value: 4096, label: '4096 bits' },
];
